const COLORS = Object.freeze({
  honeydew: '#e9fbea',
  celadon: '#bdf4c1',
  lightGreen: '#92ed97',
  malachite: '#66e66d',
  sgbusGreen: '#3adf44',
  limeGreen: '#20c52a',
  forestGreen: '#199921',
  officeGreen: '#126d18',
  pakistanGreen: '#0b420e',
  nightGreen: '#041605',

  azureWeb: '#eafbf8',
  celeste: '#bff3ea',
  tiffanyBlue: '#94ebdd',
  turquoise: '#69e3cf',
  strongTurquoise: '#3edbc1',
  keppel: '#24c1a8',
  persianGreen: '#1c9683',
  pineGreen: '#146b5d',
  brunswickGreen: '#0c4038',
  richBlack: '#041513',

  lavendarBlush: '#fbeaee',
  orchidPink: '#f3bfcd',
  amaranthPink: '#eb94ab',
  blush: '#e36989',
  cerise: '#db3e68',
  roseRed: '#c1244e',
  claret: '#961c3d',
  darkClaret: '#6b142c',
  chocolateCosmos: '#400c1a',
  licorice: '#150409',

  floralWhite: '#fbf6ea',
  dutchWhite: '#f3e4bf',
  peachYellow: '#ebd294',
  metallicGold: '#e3c069',
  gold: '#dbae3e',
  satinGold: '#c19424',
  goldenBrown: '#96731c',
  fieldDrab: '#6b5214',
  drabDarkBrown: '#40310c',
  smokeyBlack: '#151004',

  whiteSmoke: '#f2f2f2',
  platinum: '#d9d9d9',
  silver: '#bfbfbf',
  shinySilver: '#a6a6a6',
  battleShipGray: '#8c8c8c',
  dimGray: '#737373',
  davyGray: '#595959',
  onyx: '#404040',
  eerieBlack: '#262626',
  night: '#0d0d0d',

  white: '#ffffff',
  whiteLowTransparent: '#ffffff80',
  whiteHighTransparent: 'ffffff60',

  black: '#0d0d0d',
  blackLowTransparent: '#0d0d0d80',
  blackHighTransparent: '#0d0d0d60',
});

export default COLORS;
